import * as Yup from "yup"

export const companyValidationSchema = (t) =>
  Yup.object().shape({
    name: Yup.string()
      .nullable()
      .required(t("global.name_is_required", "Name is required"))
      .min(2, t("global.name_must_be_atleast_two ", "Name needs to be at least 2 characters long")),
    organisationNumber: Yup.number()
      .nullable()
      .typeError(
        t("global.organization_number_must_be_a_number", "Organization number needs to be a number")
      ),
    streetAddress: Yup.string().nullable(),
    postalCode: Yup.number()
      .typeError(t("global.postnumber_number_must_be_a_number", "Postal code needs to be a number"))
      .nullable(),
    cityAddress: Yup.string().nullable()
  })

export const step1 = (t) =>
  Yup.object().shape({
    existingName: Yup.boolean(),
    name: Yup.string()
      .nullable()
      .when("existingName", {
        is: (value) => value === true,
        then: (schema) =>
          schema.matches(true, t("global.customer_is_already_registered", "Customer is already registered"))
      })
      .required(t("global.name_is_required", "Name is required"))
      .min(2, t("global.name_must_be_atleast_two ", "Name needs to be at least 2 characters long")),
    organisationNumber: Yup.number()
      .typeError(t("organization_number_must_be_a_number", "Organization number needs to be a number"))
      .required(t("global.organization_number_is_required", "Organization number is required"))
      .nullable(),
    streetAddress: Yup.string().nullable(),
    postalCode: Yup.number()
      .nullable()
      .typeError(t("global.postnumber_number_must_be_a_number", "Postal code needs to be a number")),
    cityAddress: Yup.string().nullable()
  })
export const step2 = (t) =>
  Yup.object().shape({
    modules: Yup.array()
  })

export const step3 = (t) =>
  Yup.object().shape({
    companies: Yup.array().of(companyValidationSchema(t))
  })

export const step4 = (t) =>
  Yup.object().shape({
    adminUser: Yup.object().shape({
      name: Yup.string().nullable().required(t("global.name_is_required", "Name is required")),
      existingUsername: Yup.boolean(),
      username: Yup.string()
        .nullable()
        .when("existingUsername", {
          is: (value) => value === true,
          then: (schema) =>
            schema.matches(
              true,
              t("global.username_is_already_registered", "User name is already registered")
            )
        })
        .when("useUsername", {
          is: (value) => value === false,
          then: (schema) => schema.email(t("global.email_is_malformed", "Email is malformed"))
        })
        .required(t("global.username_is_required", "User name is required")),
      sendEmailOnCreate: Yup.boolean(),
      email: Yup.string()
        .nullable()
        .email(t("global.email_is_malformed", "Email is malformed"))
        .when("sendEmailOnCreate", {
          is: (value) => value === true,
          then: (schema) =>
            schema.required(
              t(
                "settings.user.email_is_required_if_you_have_also_chosen_to_send",
                "Email is required if you have also chosen to send email with login details"
              )
            )
        }),
      password: Yup.string()
        .nullable()
        .required(t("global.password_is_required", "Password is required"))
        .matches(
          "(?=(.*[A-Z])+)(?=(.*[a-z])+)(?=(.*[0-9])+).{8,}$",
          t(
            "settings.user.password_must_be_at_least_8_characters_long",
            "Password must be at least 8 characters long, one uppercase letter, one lowercase letter and one number"
          )
        ),
      adminSendEmailOnCreate: Yup.bool()
    })
  })
